<template>
  <v-row justify="center">
    <v-dialog v-model="dialogLocal" max-width="350px">
        <v-card>
            <v-form ref="loginForm" action="#" @submit.prevent="validateBeforeSubmit" lazy-validation>
            <v-card-title class="justify-space-between" :style="{'background-color': '#FBCE07'}" style="color: white; padding-top: 5px; padding-bottom: 5px">
            Add Mobile Number
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="black">fas fa-times</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center">
                            <v-text-field required :rules="user.rule" v-model="user.mobile" light="light" prepend-icon="fa-phone-square-alt" label="Mobile No." placeholder="60123456789" type="text"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn type="submit" small color="primary" :loading="loading" :disabled="loading">
                                    Save
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                            </v-btn>    
            <v-btn small dark color="red darken-1" @click="$emit('closed', false)">Close</v-btn>
            </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <tac :dialog="ex.modal" @closed="onClosed" :content="ex.content.mobileno"></tac>
    <v-snackbar
        v-model="toaster"
        :color="toasterColor"
        top
        >
        {{ toastertxt }}
    </v-snackbar>
  </v-row>
</template>

<script>
import tac from './TAC';
import timer from '../../assets/js/sleeper';

  export default {
    props: ['dialog', 'content'],

    data() {
        return {
            dialogLocal: false,
            user: {
                mobile: '',
                rule: []
            },
            loading: false,
            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: '',
                    mobileno: ''
                }
            },
            toaster: false,
            toastertxt: '',
            toasterColor: 'red',
        }
    },

    components: {
        tac
    },

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
        },
        },

        dialogLocal: {
        handler: function(value) {
            if (value == false)
                this.user.mobile = '';
                this.user.rule = [];

            this.modalCloseHandler();
        },
        },
    },

    methods: {
        async link(){
            this.loading = true

            try{
                let response = await this.$store.dispatch("linkMobileToEmailCustomer", {
                    mobile: this.user.mobile,
                })
                this.$emit('closed', false);
                if (response.data.code === 'AP000')
                {
                    //localStorage.setItem('tempitem', 'registered');
                    this.loading = false;
                    this.ex.modal = true;
                    this.ex.content.mobileno = this.user.mobile;
                }

                else if (response.data.code === 'AP104')
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong";
                }

                else
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong";
                }
            }

            catch(err){
                this.loading = false;
                this.toaster = true;
                this.toastertxt = "API Error";
            }
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false)
            this.$emit('closed', false);
        },

        validateBeforeSubmit() {
            this.user.rule = [];

            this.user.rule = [
                v => !!v || 'Mobile No. is required',
                v => /^(60)[0-9]{1,2}-*[0-9]{7,8}$/.test(v) || 'Please enter a valid mobile no including country code'
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
             if (self.$refs.loginForm.validate()) {
                    self.link();
                }
            });
        },

        onClosed(value){
            if (value == false){
                this.autoRefresh = 1;
                this.ex.modal = value;
            }
        },
    }
  }
</script>